import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,LoadingController} from 'ionic-angular';

import {FinancialdetailsPage} from '../financialdetails/financialdetails';
import {YourPropertyPage} from '../your-property/your-property';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { CommonProvider } from '../../providers/common/common';
/**
 * Generated class for the AppLoanRequirementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-loan-requirement',
  templateUrl: 'app-loan-requirement.html',
})
export class AppLoanRequirementPage {
  model:any={}
  arrLoanType:any=[];
  previousData:any = {}
  name:any=""
  cities:any=[]
  cityFlag:any=false
  cityAfterFillterBlank:any=[]
  ibhfl_purposeproductFlag:any=false;
  propertyType:any=[];
  propertyObj:any={};
  errorDisplay:any={};
  errorSingleDisplay:any={}

  constructor(private fb: FormBuilder,private fv : GenericFormValidationProvider,private cp: CommonProvider, public loadingCtrl: LoadingController,
    public navCtrl: NavController, public navParams: NavParams) {
    this.model.lead={}
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppLoanRequirementPage',this.navParams.data);
    this.previousData = JSON.parse(this.navParams.data);
     
    this.model.lead.ibhfl_LoanTypeId = this.previousData.Payload.lead.ibhfl_LoanTypeId;

    this.model.lead.estimatedamount = this.numberFormatter( this.previousData.Payload.lead.estimatedamount);
    
    this.model.lead.ibhfl_loantenure = this.previousData.Payload.lead.ibhfl_loantenure?this.previousData.Payload.lead.ibhfl_loantenure:"20";
     
    this.name = this.previousData.Payload.lead.applicants[0].ibhfl_firstname;
    localStorage.setItem("name",this.previousData.Payload.lead.applicants[0].ibhfl_firstname);
    if(this.previousData.Payload.lead.properties.length>0){
      this.model.lead.ibhfl_PropertyCity_name = this.previousData.Payload.lead.properties[0].ibhfl_city_name;
      this.model.lead.ibhfl_PropertyCity = this.previousData.Payload.lead.properties[0].ibhfl_PropertyCityId;
    }
    
    if(this.previousData.Payload.lead.ibhfl_purposeproduct=='HL'){
      this.ibhfl_purposeproductFlag=false
    }else{
      this.ibhfl_purposeproductFlag=true

    }
    this.model.lead.ibhfl_PropertyTypeId=this.previousData.Payload.lead.ibhfl_PropertyTypeId;
    this.model.lead.ibhfl_propertytype_name=this.previousData.Payload.lead.ibhfl_propertytype_name;
    this.getAddressType(this.previousData.Payload.lead.ibhfl_purposeproduct)
    this.getLoanType();
    this.cityMaster();
    this.model.lead.properties=[];
     this.model.lead.leadid=this.previousData.Payload.lead.leadid;
     this.model.lead.properties = this.previousData.Payload.lead.properties;
     if(this.model.lead.properties && this.model.lead.properties.length>0){
      this.model.lead.properties.forEach((data:any)=>{
        data.leadid=this.previousData.Payload.lead.leadid
        data.ibhfl_isplot=false

      })
     }else{
       this.model.lead.properties=[{}]
       this.model.lead.properties[0].leadid=this.previousData.Payload.lead.leadid
       this.model.lead.properties[0].ibhfl_isplot=false
     }

  }
  checkAmount(event){
    var amount = event.target.value.replaceAll(',', '')
    if(parseInt(amount)<500000){
      this.errorDisplay.loan_amount="Required loan amount should be at least 5,00,000";
      this.errorDisplay.valid=true;
    }else{
      this.errorDisplay.loan_amount="";
      this.errorDisplay.valid=false;
    }
  }
  changeFunction(event){
     
    this.model.lead.ibhfl_loantenure = event._value
  }
  getAddressType(loanType){
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
    let request:any={}
    request.propertyType=  loanType  
    this.cp.propertyType(loading,request).then((res:any)=>{
      loading.dismiss();
         
        this.propertyType = JSON.parse(res).Payload.propertytypes
         this.propertyType.sort((a, b) => {
            return parseInt(a.ibhfl_code) - parseInt(b.ibhfl_code);
        });
         //console.log("this.propertyType",this.propertyType)
         this.propertyObj=this.propertyType[0];
          
        

    })
  }
  changeAddressType(objPro){
    //console.log("test one",objPro);

     this.propertyObj=this.propertyType.filter((res:any)=>{
      return res.ibhfl_code==objPro
     })
     this.model.lead.ibhfl_PropertyTypeId=this.propertyObj[0].ibhfl_code;
     this.model.lead.ibhfl_propertytype_name=this.propertyObj[0].ibhfl_name;
  }
  onChangeAmount(){
    if(this.model.lead.ibhfl_loantenure==0 || this.model.lead.ibhfl_loantenure==1){
      this.model.lead.ibhfl_loantenure="2"
    }
  }
  updateTenure(value){
    if(value==0){
      this.model.lead.ibhfl_loantenure="1"
    }else{
      if(value>25){
        this.model.lead.ibhfl_loantenure="2"
      }else{
        if(!value){
          this.model.lead.ibhfl_loantenure="0"
        }else{
          this.model.lead.ibhfl_loantenure=value
        }
        
      }
    }
    
    
  }
  getLoanType(){
    

    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
    let request:any={}
        
    this.cp.getLoanType(loading,request).then((res:any)=>{
      loading.dismiss();
        //console.log(JSON.parse(res).Payload,"Loantypes")
        this.arrLoanType = JSON.parse(res).Payload.loantypes
        this.arrLoanType.sort((a, b) => {
            return a.ibhfl_code - b.ibhfl_code;
        });

    })
  }
  addFocus(e){
   this.cityFlag=false
  }
  search(e){
    //console.log(e)
    if(e.keyCode=="8"){
      this.cities = this.cityAfterFillterBlank;
    }
     let val = e.target.value;
    

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.cityFlag=true
      this.cities = this.cities.filter((item) => {
        return (item.ibhfl_name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })

    }else{
      this.cityFlag=false
      this.cities = this.cityAfterFillterBlank;
    }
  }
  cityMaster(){
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
    let request:any={}
        
    this.cp.cityMaster(loading,request).then((res:any)=>{
      loading.dismiss(); 
      //console.log("citymaster",JSON.parse(res).Payload.ibhfl_cities)
      this.cities = JSON.parse(res).Payload.ibhfl_cities
      this.cityAfterFillterBlank = JSON.parse(res).Payload.ibhfl_cities

    })
  }
   
  removeFocus(e){
    //console.log(e)
  }
  addCity(city){
    this.cityFlag=false
    this.model.lead.ibhfl_PropertyCity_name = city.ibhfl_name;
    this.model.lead.ibhfl_PropertyCity = city.ibhfl_citycode;
    if(this.model.lead.properties.length>0){
      this.model.lead.properties.forEach((data:any)=>{
        data.leadid=this.previousData.Payload.lead.leadid
        data.ibhfl_isplot=false
        data.ibhfl_PropertyCityId = city.ibhfl_citycode;
        data.ibhfl_PropertyCity_name = city.ibhfl_name;
         


      })
     }else{
      this.model.lead.properties=[{}]
       this.model.lead.properties[0].leadid=this.previousData.lead.leadid
       this.model.lead.properties[0].ibhfl_isplot=false
       this.model.lead.properties[0].ibhfl_PropertyCityId = city.ibhfl_citycode
        
       this.model.lead.properties[0].ibhfl_PropertyCity_name= city.ibhfl_name;
     }


    
  }
   createApplicantByLeadID(propertyObj){
     let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
           
          let request : any={
              "lead": {
                  "leadid": this.model.lead.leadid,
                  "properties": [
                       propertyObj
                  ]
                  }
                   
              }
              
          //console.log(".....................",request)
      this.cp.createLead(loading,request).then((res:any)=>{
         loading.dismiss();
         try{
              //console.log(JSON.parse(res).Payload.lead.propertyIds[0])
            this.newUpdateLead(JSON.parse(res).Payload.lead.leadid,JSON.parse(res).Payload.lead.propertyIds[0])
           
         }catch(e){
           
         } 
           
      })
  }
   
  checkValidation(keyname?:any){
   if(Object.keys(this.errorDisplay).length>0){
    this.errorSingleDisplay = this.fv.checkValidationFormAllControls(document.forms['app-loan-requirement'],true,[]);
    if(Object.keys(this.errorSingleDisplay).length>0){
     var index = Object.keys(this.errorSingleDisplay).findIndex((res:any)=>{
        return res==keyname
      })
        console.log(index);

      if(index==-1){
        delete this.errorDisplay[keyname];
        if(this.errorDisplay.length>0 && this.errorDisplay.length<=1)
        {
          this.errorDisplay.valid=false
        }
        console.log(this.errorDisplay);
      }
    }
    
   }
   
  }
  updateLead(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms["app-loan-requirement"],true,[]);
    var amount = this.model.lead.estimatedamount?this.model.lead.estimatedamount.toString().replaceAll(',',""):"";
    if(parseInt(amount)<500000){
      this.errorDisplay.loan_amount="Required loan amount should be at least "+this.numberFormatter('500000');
      this.errorDisplay.valid=true;
    }
    if(!this.model.lead.ibhfl_PropertyCity_name){
      //console.log(this.model.lead.ibhfl_PropertyCity_name)
      this.errorDisplay.City="City is required";
      this.errorDisplay.valid=true;
    }
    if(!this.model.lead.ibhfl_LoanTypeId){
      //console.log(this.model.lead.ibhfl_PropertyCity_name)
      this.errorDisplay.ibhfl_LoanTypeId="Loan type is required";
      this.errorDisplay.valid=true;
    }
    
   if(this.errorDisplay.valid){
     return false;
   }else{
    if(!this.model.lead.properties[0].propertyid){
          this.createApplicantByLeadID(this.propertyObj)
    }else{
         this.newUpdateLead(this.model.lead.properties[0].leadid,this.model.lead.properties[0].propertyid)
    }
   }

    

  }
  newUpdateLead(leadid,propertyLeadId){
    //console.log("updated lead data for loan property",this.model)
    let loading = this.loadingCtrl.create({
           content: 'Please wait...'
          });
          loading.present();
    this.model.lead.ibhfl_stageid= "2"
    this.model.lead.ibhfl_isplot= false
    this.model.lead.ibhfl_loantenure=this.model.lead.ibhfl_loantenure.toString();
    
    this.model.lead.estimatedamount=this.model.lead.estimatedamount?parseInt(this.model.lead.estimatedamount.toString().replaceAll(',',"")):0;
     
         this.cp.updateLead(loading,this.model).then((res:any)=>{
      loading.dismiss();
       
       try{
        //console.log("vvvvvvvvv",JSON.parse(res).Payload)
          if(JSON.parse(res).Payload){
            if(this.ibhfl_purposeproductFlag){
              this.navCtrl.push(YourPropertyPage,{"data":this.navParams.data,"selectedtype":this.model.lead.ibhfl_PropertyTypeId
            })
            }else{
              this.navCtrl.push(FinancialdetailsPage,this.navParams)
            }
            
         }else{

         }
       }catch(e){
        //console.log("error getting",e);
       }
       

       
       
    })

  }
isNumberKey(event) {
  let charCode = event.which ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
   return false;
  }
  return true;
  }

changeAmountFormat(keyname,model,value){
  if(!value){

  }else{
      if(value.toString().replaceAll(",","")>0){
        this.model.lead.estimatedamount=this.numberFormatter(value.toString().replaceAll(",",""));
      }
  }

  
  
}  

numberFormatter(x) {
    if(!x){
      return
    }else{
      x = x.toString();
      var afterPoint = '';
      if (x.indexOf('.') > 0)
          afterPoint = x.substring(x.indexOf('.'), x.length);
      x = Math.floor(x);
      x = x.toString();
      var lastThree = x.substring(x.length - 3);
      var otherNumbers = x.substring(0, x.length - 3);
      if (otherNumbers != '')
          lastThree = ',' + lastThree;
      var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint;
      return res;
    } 
    
}
}



// WEBPACK FOOTER //
// ./src/pages/app-loan-requirement/app-loan-requirement.ts